import { render, staticRenderFns } from "./on-course-dashboard.vue?vue&type=template&id=41883400"
import script from "./on-course-dashboard.vue?vue&type=script&lang=js"
export * from "./on-course-dashboard.vue?vue&type=script&lang=js"
import style0 from "./on-course-dashboard.vue?vue&type=style&index=0&id=41883400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports